export const viewDetailDialogPt = {
  root: { class: "w-[50vw] max-h-[50vh] flex flex-col rounded-xl overflow-hidden shadow-xl" },
  header: { class: "px-6 py-4 bg-teal-50 border-b border-teal-100 flex-shrink-0 flex items-center justify-between" },
  title: { class: "font-semibold text-gray-900 text-base" },
  headerActions: { class: "flex items-center ml-auto !rounded-none !outline-teal-50 !outline-0 !focus:outline-none" },
  closeButton: {
    class:
      "w-7 h-7 flex items-center justify-center !rounded-none text-gray-500 !border-none !outline-teal-50 !outline-0 !focus:outline-none",
  },
  closeButtonIcon: { class: "hidden" },
  content: { class: "px-6 py-5 overflow-y-auto flex-1 bg-white" },
};
